export const config = {
    keyNameCookie: 'zero-carbon-auth.session-token',
    reCaptCha: '6Lc1zyoqAAAAAF1_TFTdU0_2rMl_TfMHmm9fe4kW',
    keyGOOGLE_OAUTH_CLIENT_ID: '436111871402-j1gtl6d8q9jiou92otqdus98heorf2ko.apps.googleusercontent.com',

    rowsPerPageOptions: [10, 20, 50, 100],
};
